<template>
	<div class="search">
		<div class="form-item mr-24">
			<div class="form-label fz-14">平台</div>
			<div class="content">
				<platform-select v-model="search.platformId" @input="platformChange" :showAll="notSingleVersion" style="width: 240px"></platform-select>
			</div>
		</div>
		<div class="form-item mr-24" v-if="showDeptSelect && isAllDataView">
			<div class="form-label fz-14">部门</div>
			<div class="content">
				<deptTreeSelect
					style="width: 240px"
					@change="refresh"
					returnArray
					v-model="search.deptIds"
					:collapseTags="true"
					size="small"
					ref="deptTreeSelect"
				/>
			</div>
		</div>

		<div class="form-item">
			<div class="form-label fz-14">团长</div>
			<div class="content">
				<commander-select @change="refresh" :platformId="search.platformId" v-model="search.authority_id"></commander-select>
			</div>
		</div>
		<div class="form-item mr-24">
			<div class="content">
				<div class="flex">
					<Time-select class="mr-8" @changeSelect="changeSelect($event)"></Time-select>
					<el-date-picker
						class="date-picker"
						size="mini"
						value-format="timestamp"
						v-model="search.inofTime"
						type="daterange"
						align="right"
						unlink-panels
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:clearable="false"
						@change="refresh"
						:picker-options="pickerOptions"
						style="width: 250px; height: 32px"
					/>
				</div>
			</div>
		</div>
		<div class="form-item mr-24">
			<div class="form-label fz-14">员工</div>
			<div class="content">
				<staff-select v-model="search.userId" @change="refresh" style="width: 240px"></staff-select>
			</div>
		</div>
		<div class="form-item">
			<defaultFilterTag
				@applicationSetting="applicationSetting"
				:dynamicsList="dynamicsList"
				:defaultForm="defaultForm"
				:listType="listType"
				slot="operate"
				:platformId="defaultForm.platformId"
			/>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect.vue';
import TimeSelect from '../components/timeSelect';
import { calDate, disabledDate } from '@/utils/common';
import staffSelect from '@/components/business/staffSelect/index.vue';
import commanderSelect from '@/components/commanderSelect/index.vue';
import { PLATFORM_ALL } from '@/utils/dataMap';
import defaultFilterTag from '@/components/business/defaultFilter';
import { pageConfig } from '@/utils/dataMap';
import { configList } from './searchConfig';
export default {
	data() {
		const setTime = (picker, value) => picker.$emit('pick', calDate(value));
		return {
			search: {
				platformId: '',
				deptIds: [],
				inofTime: calDate(7),
				userId: '',
				timeType: '1',
			},
			defaultForm: {
				platformId: '',
				deptIds: [],
			},
			pickerOptions: {
				shortcuts: [
					{ text: '昨天', onClick: picker => setTime(picker, 1) },
					{ text: '7天', onClick: picker => setTime(picker, 7) },
					{ text: '15天', onClick: picker => setTime(picker, 15) },
					{ text: '30天', onClick: picker => setTime(picker, 30) },
					{ text: '90天', onClick: picker => setTime(picker, 90) },
					{ text: '180天', onClick: picker => setTime(picker, 180) },
				],
				disabledDate: time => disabledDate(time, process.env.VUE_APP_ENV == 'gray' ? 3650 : 365, false),
			},
			listType: pageConfig.performanceManageSearch,
		};
	},
	components: {
		deptTreeSelect,
		TimeSelect,
		staffSelect,
		commanderSelect,
		defaultFilterTag,
	},
	computed: {
		...mapGetters(['notSingleVersion', 'showDeptSelect', 'isAllDataView', 'defaultPlatform']),
		dynamicsList({ notSingleVersion }) {
			let arr = [
				{
					label: '平台',
					key: 'platformId',
					type: 'component',
					component: () => import('@/components/platformSelect'),
					isShow: true,
					showAllPlatform: notSingleVersion,
				},
			];
			return [...arr, ...configList];
		},
	},
	methods: {
		changeSelect(val) {
			//val为1代表付款时间，2代表结算时间
			this.search.timeType = val;
			this.refresh();
		},
		platformChange() {
			this.search.authority_id = '';
			this.search.inofTime = calDate(7);
			this.refresh();
		},
		applicationSetting(val) {
			let inofTime = this.search.inofTime;
			let timeType = this.search.timeType;
			this.search = { ...val, inofTime, timeType };
			this.refresh();
		},
		refresh() {
			this.$emit('change', this.search);
		},
	},
	created() {
		this.search.inofTime =
			this.$route?.query.startEndTime?.split(',').map(timestamp => {
				return new Date(+timestamp * 1000);
			}) || calDate(7);
		this.search.platformId = +this.$route?.query.platformId || (this.notSingleVersion ? +PLATFORM_ALL.value : +this.defaultPlatform);
		this.search.authority_id = this.$route?.query.authority_id || '';
		if (Object.keys(this.$route.query).length !== 0) {
			this.$emit('change', this.search);
		}
		this.defaultForm.platformId = this.search.platformId;
	},
};
</script>
<style lang="less" scoped>
.search {
	display: flex;
	flex-wrap: wrap;
	.form-item {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		.form-label {
			min-width: 40px;
			color: @color-text-regular;
		}
	}
	.content {
		flex: 1;
	}
	.date-picker {
		/deep/ .el-range-input {
			font-size: 14px;
		}
	}
}
</style>
